import React, { useContext, useState, useEffect } from 'react';
import Fade from 'react-reveal/Fade';
import { Container, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Title from '../Title/Title';
import AboutImg from '../Image/AboutImg';
import PortfolioContext from '../../context/context';
import pdf from '../../images/Kevin-Resume.pdf'

const About = () => {
  const { about } = useContext(PortfolioContext);
  const { skills, resume } = about;

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  return (
    <section id="about">
      <Container>
        <Title title="Skills" />
        <Row className="about-wrapper">
          <Col>
            <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={1000} distance="30px">
              <div className="about-wrapper__info">
                <div className="about-wrapper__skills">
                {skills && skills.map(skill=>{
                  let newWord = skill.replace('.png','');
                  return(
                    <div className="about-wrapper__skills__image">
                      <AboutImg alt={newWord} filename={skill}/>
                      <h3>{newWord}</h3>
                    </div>
                  )
                })}
                </div>
                {resume && (
                  <span className="d-flex mt-5 mx-auto pt-2">
                    <a
                      target="_blank"
                      className="cta-btn cta-btn--resume py-3 px-4"
                      href={pdf}
                    >
                      Resume
                    </a>
                  </span>
                )}
              </div>
            </Fade>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
